var MaintenanceTypeModule = /** @class */ (function () {
    function MaintenanceTypeModule() {
    }
    return MaintenanceTypeModule;
}());
export { MaintenanceTypeModule };
